// extracted by mini-css-extract-plugin
export default {"title":"L6MhSDMV","mobile":"mobile","envelope":"aZNLB2WR","money":"VMEFXdZK"};